export default __webpack_public_path__ + "static/media/369labs.eec749fb.png";